import {
  Box,
  Divider,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import MultiCheckBoxes from "../../../../Components/MultiCheckBox/MultiCheckBoxes";
import MuiButton from "../../../../Components/Button/Button";
import MuiInputField from "../../../../Components/InputField/InputField";
import FileUpload from "../../../../Components/FileUpload/FileUpload";
import CloseIcon from "@mui/icons-material/Close";
import MultiSelectDropDown from "../../../../Components/DropDown/MultiSelectDropDown";
import TextEditor from "../../../../Components/TextEditor/TextEditor";
import DropDown from "../../../../Components/DropDown/DropDown";
import { isEditable } from "@testing-library/user-event/dist/utils";
import { downloadBase64File } from "../../../../Utils/helper";
import docIcon from "../../../../Assets/Hospital/doc.svg";
import { TextView } from "../../../../Components/TextView";

export function PersonalDetailsView(props) {
  return (
    <Box
      border={"1px solid lightgrey"}
      borderRadius={2}
      marginTop={2}
      paddingX={5}
      paddingY={5}
    >
      <Grid
        container
        item
        lg={12}
        justifyContent={"flex-start"}
        alignItems={"center"}
      >
        <Grid item lg={10.8}>
          <MultiCheckBoxes
            isDisabled={props?.isEditable}
            setCheckedItems={props?.setCheckedItems}
            setCheckedItemsId={props?.setCheckedItemsId}
            checkedItems={props?.checkedItems}
            items={props?.items}
          />
        </Grid>
      </Grid>

      <Grid
        container
        item
        marginTop={"30px"}
        lg={12}
        justifyContent={"space-between"}
        alignItems={"flex-start"}
      >
        <Grid item lg={3.8}>
          <Typography
            sx={{
              fontWeight: "600",
              fontSize: "14px",
              color: "#4c5a6a",
              paddingBottom: "7px",
            }}
          >
            Doctor Name
          </Typography>
          {props.isEditable ? (
            <MuiInputField
              value={props?.details?.name}
              onChange={(event) => {
                props?.setDetails((s) => ({
                  ...s,
                  name: event.target.value,
                }));
              }}
              placeHolder={"Enter the Doctor name"}
            />
          ) : (
            <TextView>{props?.details?.name}</TextView>
          )}
        </Grid>
        <Grid item lg={3.8}>
          <Typography
            sx={{
              fontWeight: "600",
              fontSize: "14px",
              color: "#4c5a6a",
              paddingBottom: "7px",
            }}
          >
            Medical Counsil Registration Number
          </Typography>
          {props.isEditable ? (
            <MuiInputField
              type="number"
              value={props?.details?.registrationNumber}
              onChange={(event) => {
                props?.setDetails((s) => ({
                  ...s,
                  registrationNumber: event.target.value,
                }));
              }}
              placeHolder={"Add Registration Number"}
            />
          ) : (
            <TextView>{props?.details?.registrationNumber}</TextView>
          )}
        </Grid>
        <Grid item lg={3.8}>
          <Typography
            sx={{
              fontWeight: "600",
              fontSize: "14px",
              color: "#4c5a6a",
              paddingBottom: "7px",
            }}
          >
            Upload Medical Counsil Doc & Others Docs
          </Typography>

          {props?.doc?.document?.length !== 0 ? (
            <Grid
              sx={{
                display: "flex",
                overflowY: "hidden",
                overflowX: "auto",
                "&::-webkit-scrollbar": {
                  height: "5px",
                  width: "10px",
                  backgroundColor: "lightgray",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "grey",
                  borderRadius: "30px",
                },
                "&::-webkit-scrollbar-thumb:hover": {
                  background: "grey",
                },
              }}
            >
              {props?.doc?.document?.map((val, i) => {
                return (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "74px",
                      height: "74px",
                      border: "1px solid lightgray",
                      borderRadius: "10px",
                      marginLeft: "10px",
                    }}
                    onClick={() =>
                      downloadBase64File(
                        `data:${val.documentType};base64,${val.document}`,
                        val.documentName
                      )
                    }
                  >
                    <Box
                      component="img"
                      src={docIcon}
                      sx={{
                        width: "60px",
                        height: "60px",
                        objectFit: "contain",
                        ":hover": { transform: "scale(1.5)" },
                        cursor: "pointer",
                      }}
                    />
                  </div>
                );
              })}
            </Grid>
          ) : (
            "N/A"
          )}
        </Grid>
      </Grid>

      <Grid
        container
        item
        marginTop={"30px"}
        lg={12}
        justifyContent={"space-between"}
        alignItems={"flex-start"}
      >
        <Grid item lg={3}>
          <Typography
            sx={{
              fontWeight: "600",
              fontSize: "14px",
              color: "#4c5a6a",
              paddingBottom: "7px",
            }}
          >
            Upload Doctor Image
          </Typography>

          {props.isEditable || props?.doc?.image?.length !== 0 ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "74px",
                height: "74px",
                border: "1px solid lightgray",
                borderRadius: "10px",
                marginLeft: "10px",
                overflow: "hidden",
              }}
            >
              {props?.doc?.image?.map((val) => {
                return (
                  <Grid height={100} width={100}>
                    <Box
                      component="img"
                      src={`data:${val.documentType};base64,${val.document}`}
                      sx={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                      }}
                    />
                  </Grid>
                );
              })}
            </div>
          ) : (
            "N/A"
          )}
        </Grid>
        <Grid item lg={3.8}>
          <Typography
            sx={{
              fontWeight: "600",
              fontSize: "14px",
              color: "#4c5a6a",
              paddingBottom: "7px",
            }}
          >
            Qualification
          </Typography>
          {props?.details?.qualifications?.length
            ? props?.details?.qualifications.map((val) => {
                return <TextView>{val?.name}</TextView>;
              })
            : "N/A"}
        </Grid>
        <Grid item lg={3}>
          <Typography
            sx={{
              fontWeight: "600",
              fontSize: "14px",
              color: "#4c5a6a",
              paddingBottom: "7px",
            }}
          >
            Experience
          </Typography>
          {props.isEditable ? (
            <MuiInputField
              type="number"
              value={props?.details?.startYear}
              onChange={(event) => {
                props?.setDetails((s) => ({
                  ...s,
                  startYear: event.target.value,
                }));
              }}
              placeHolder={"Add Experience (Start Year)"}
            />
          ) : (
            <TextView>{props?.details?.startYear}</TextView>
          )}
        </Grid>
      </Grid>

      <Grid
        container
        item
        marginTop={"30px"}
        lg={12}
        justifyContent={"space-between"}
        alignItems={"flex-end"}
      >
        <Grid item lg={3}>
          <Typography
            sx={{
              fontWeight: "600",
              fontSize: "14px",
              color: "#4c5a6a",
              paddingBottom: "20px",
              paddingTop: "20px",
            }}
          >
            Departments
          </Typography>
          {props.isEditable ? (
            <DropDown
              placeHolder={"Select Department"}
              viewHeight={"44px"}
              borderRadius={"5px"}
              bgColor="white"
              border="2px solid #e9eff7"
              viewWidth="100%"
              data={props.departments}
              value={props?.details?.department}
              handleSelected={(e, value) => {
                props?.setDetails((s) => ({
                  ...s,
                  departmentId: value.id,
                }));
                props?.setDetails((s) => ({
                  ...s,
                  department: value,
                }));
              }}
            />
          ) : (
            <TextView>{props?.details?.department?.name}</TextView>
          )}
        </Grid>
        <Grid item lg={3}>
          <Typography
            sx={{
              fontWeight: "600",
              fontSize: "14px",
              color: "#4c5a6a",
              paddingBottom: "20px",
              paddingTop: "20px",
            }}
          >
            Working Hospital
          </Typography>
          {props.isEditable ? (
            <DropDown
              placeHolder={"Select Hospital"}
              viewHeight={"44px"}
              borderRadius={"5px"}
              bgColor="white"
              border="2px solid #e9eff7"
              viewWidth="100%"
              data={props?.centers}
              value={props?.details?.centers}
              handleSelected={(e, value) => {
                props?.setDetails((s) => ({
                  ...s,
                  centerId: value?.id,
                }));
                props?.setDetails((s) => ({
                  ...s,
                  centerId: value,
                }));
              }}
            />
          ) : (
            <TextView>{props?.details?.centers?.name}</TextView>
          )}
        </Grid>
        <Grid item sx={{ marginBottom: "10px" }} lg={4}>
          <Typography
            sx={{
              fontWeight: "600",
              fontSize: "14px",
              color: "#4c5a6a",
              paddingBottom: "7px",
            }}
          >
            Contact Number
          </Typography>
          {props.isEditable ? (
            <MuiInputField
              type="number"
              maxlength={10}
              value={props?.details?.contactNumber}
              onChange={(event) => {
                props?.setDetails((s) => ({
                  ...s,
                  contactNumber: event.target.value,
                }));
              }}
              placeHolder={"Contact Number"}
            />
          ) : (
            <TextView>{"+91 " + props?.details?.contactNumber}</TextView>
          )}
        </Grid>
      </Grid>
      <Grid
        container
        item
        height={"80px"}
        lg={12}
        alignItems={"flex-start"}
        marginTop={"30px"}
      >
        <Grid item lg={3.8}>
          <Typography
            sx={{
              fontWeight: "600",
              fontSize: "14px",
              color: "#4c5a6a",
              paddingBottom: "7px",
            }}
          >
            Alternate Contact number (Optional)
          </Typography>
          {props.isEditable ? (
            <MuiInputField
              maxLength={10}
              type="number"
              value={props?.details?.alternateContactNumber}
              onChange={(event) => {
                props?.setDetails((s) => ({
                  ...s,
                  alternateContactNumber: event.target.value,
                }));
              }}
              placeHolder={"add alternate Contact number"}
            />
          ) : (
            props?.details?.alternateContactNumber && (
              <TextView>
                {"+91 " + props?.details?.alternateContactNumber}
              </TextView>
            )
          )}
        </Grid>
        <Grid item lg={3.8} marginLeft={"32px"}>
          <Typography
            sx={{
              fontWeight: "600",
              fontSize: "14px",
              color: "#4c5a6a",
              paddingBottom: "7px",
            }}
          >
            Email
          </Typography>
          {props.isEditable ? (
            <MuiInputField
              value={props?.details?.email}
              onChange={(event) => {
                props?.setDetails((s) => ({
                  ...s,
                  email: event.target.value,
                }));
              }}
              placeHolder={"Add email id"}
            />
          ) : (
            <TextView>{props?.details?.email}</TextView>
          )}
        </Grid>
      </Grid>
      <Grid>
        <Grid>
          <Typography
            sx={{
              fontWeight: "600",
              fontSize: "14px",
              color: "#4c5a6a",
              paddingBottom: "7px",
              paddingTop: "10px",
            }}
          >
            Upload Agreement
          </Typography>
          <Grid
            sx={{
              display: "flex",
              overflowY: "hidden",
              overflowX: "auto",
              "&::-webkit-scrollbar": {
                height: "5px",
                width: "10px",
                backgroundColor: "lightgray",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "grey",
                borderRadius: "30px",
              },
              "&::-webkit-scrollbar-thumb:hover": {
                background: "grey",
              },
            }}
          >
            {props.doc?.agreementDocument?.map((val, i) => {
              return (
                <div
                  key={i}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "74px",
                    height: "74px",
                    border: "1px solid lightgray",
                    borderRadius: "10px",
                    marginLeft: "10px",
                    marginBottom: "10px",
                  }}
                  onClick={() =>
                    downloadBase64File(
                      `data:${val.documentType};base64,${val.document}`,
                      val.documentName
                    )
                  }
                >
                  <Box
                    component="img"
                    src={docIcon}
                    sx={{
                      width: "60px",
                      height: "60px",
                      objectFit: "contain",
                      ":hover": { transform: "scale(1.5)" },
                      cursor: "pointer",
                    }}
                  />
                </div>
              );
            })}
          </Grid>
        </Grid>
      </Grid>
      <Divider />

      <Typography
        sx={{
          fontWeight: "600",
          fontSize: "16px",
          color: "#4c5a6a",
          paddingBottom: "7px",
          paddingTop: "30px",
        }}
      >
        About Doctor
      </Typography>
      <Grid
        sx={{
          width: "100%",
          height: props.isEditable ? 300 : "auto",
          backgroundColor: props.isEditable ? "white" : "transparent",
          marginTop: "30px",
          border: props.isEditable ? "1px solid #e9eff7" : "none",
          borderRadius: "10px",
          marginBottom: "50px",
        }}
      >
        {props.isEditable ? (
          <TextEditor
            initialValue={props?.details?.about}
            onSave={(textValue) => {
              console.log("Text value:", textValue);
              props?.setDetails((s) => ({
                ...s,
                about: textValue,
              }));
            }}
          />
        ) : (
          <TextView>{props?.details?.about}</TextView>
        )}
      </Grid>
      <Divider />
      <Grid item lg={3.8}>
        <Typography
          sx={{
            fontWeight: "600",
            fontSize: "14px",
            color: "#4c5a6a",
            paddingBottom: "7px",
          }}
        >
          Key Specialisations
        </Typography>
        {props.isEditable ? (
          <MultiSelectDropDown
            handleSelected={(e, value) => {
              props?.setDetails((s) => ({
                ...s,
                specialisationIds: value.map((val) => val.id),
              }));
              props?.setDetails((s) => ({
                ...s,

                specialities: value.map((val) => val),
              }));
            }}
            placeholder="Choose Specialisation"
            data={props?.specialization}
            value={props.details.specialities}
          />
        ) : (
          props?.details?.specialities?.map((val) => {
            return <TextView>{val?.name}</TextView>;
          })
        )}
      </Grid>
      <Grid container lg={12} marginY={"20px"} justifyContent={"flex-end"}>
        {props.isEditable && (
          <Grid lg={0.9}>
            <MuiButton
              onClick={props.onSave}
              padding="10px 30px"
              viewHeight="45px"
              bgColor="#17dfba"
              borderRadius="5px"
              title={"Save"}
            />
          </Grid>
        )}
      </Grid>
    </Box>
  );
}
